import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <Location />
      <Footer />
    </div>;
}